import { Component, OnInit } from "@angular/core";
import { TranslateModule } from "@ngstack/translate";

@Component({
  selector: "app-level-prerequisite",
  templateUrl: "./level-prerequisite.component.html",
  styleUrls: ["./level-prerequisite.component.css"]
})
export class LevelPrerequisiteComponent implements OnInit {
  constructor(public translate: TranslateModule) {}

  ngOnInit() {}
}
